import { render, staticRenderFns } from "./OverviewContent.vue?vue&type=template&id=5e4156fd"
import script from "./OverviewContent.vue?vue&type=script&lang=js"
export * from "./OverviewContent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports